// extracted by mini-css-extract-plugin
export default {"accordion":"accordion_accordion__vjxQ3","filters":"accordion_filters__zc9-w"};